import { mapGetters } from 'vuex'
import formatDate from '@/module/util/format-date'
import formatDateTime from '@/module/util/format-date-time'

export default {

	methods: {
		formatDate,
		formatDateTime
	},

	computed: {
		...mapGetters('content', [
			'getContent'
		])
	}
}
